module.exports = __webpack_public_path__ + "static/partner-f2d6fce9d0eea97473c656fb83f924f2.jpg";